import React, { Component } from 'react'

export default class Header extends Component {
  render() {
    return (
      <div>
        <div className="container">
        <div className="row">
            <div className="col">
            </div>
            <div className="col-lg-10">
        <p className="title">CHRISTEN M. KERR M.D., P.C.</p>
        <p className="subtitle">PSYCHIATRIST AND THERAPIST</p>
        <p className="specialties">35 Years in Practice | Adult and Geriatric Psychiatry | Psychotherapy | Medication Management </p>
            </div>
            <div className="col">
            </div>
        </div>
        </div>
      </div>
    )
  }
}
